import { styled } from 'styled-components'

interface ConfirmDeleteModalProps {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => void
    title: string
    message: string
    isLoading?: boolean
}

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`

const ModalContent = styled.div`
    background-color: #ffffff;
    border-radius: 12px;
    padding: 32px;
    width: 90%;
    max-width: 400px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
`

const ModalTitle = styled.h3`
    font-size: 20px;
    font-weight: 600;
    color: #000000;
    margin: 0 0 16px 0;
`

const ModalMessage = styled.p`
    font-size: 14px;
    color: #666666;
    margin: 0 0 24px 0;
    line-height: 1.5;
`

const ModalButtonGroup = styled.div`
    display: flex;
    gap: 12px;
    justify-content: flex-end;
`

const CancelButton = styled.button`
    padding: 10px 24px;
    background-color: #f2f3f5;
    color: #333333;
    border: 1px solid #e5e6eb;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background-color: #e5e6eb;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`

const ConfirmButton = styled.button`
    padding: 10px 24px;
    background-color: #d32f2f;
    color: #ffffff;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #b71c1c;
    }

    &:disabled {
        background-color: #cccccc;
        cursor: not-allowed;
    }
`

export default function ConfirmDeleteModal({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    isLoading = false,
}: ConfirmDeleteModalProps) {
    if (!isOpen) return null

    return (
        <ModalOverlay onClick={onClose}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <ModalTitle>{title}</ModalTitle>
                <ModalMessage>{message}</ModalMessage>
                <ModalButtonGroup>
                    <CancelButton onClick={onClose} disabled={isLoading}>
                        Cancel
                    </CancelButton>
                    <ConfirmButton
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Deleting...' : 'Delete'}
                    </ConfirmButton>
                </ModalButtonGroup>
            </ModalContent>
        </ModalOverlay>
    )
}
